module.exports = __webpack_public_path__ + "static/media/Destijl.da339597.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Destijl.svg
// module id = 925
// module chunks = 0